module.exports = __webpack_public_path__ + "img/no-news.53532364.png";